import type { JWTPayload } from 'jose';
import { useLegacyCiam } from '../feature-flags';

export function getCookie(cookieName: string): string | null {
  const prefix = useLegacyCiam() ? 'auth0_' : 'ciam_';
  return getCookieByName(`${prefix}${cookieName}`);
}

function getCookieByName(fullCookieName: string): string | null {
  const cookies = document.cookie.split(';');
  for (const c of cookies) {
    const [name, ...value] = c.split('=');
    if (name.trim() === fullCookieName) {
      return value.join('=');
    }
  }
  return null;
}

export async function extractToken<T extends JWTPayload>(cookieName: string): Promise<T | null> {
  const cookie = getCookie(cookieName);

  if (!cookie) {
    return null;
  }

  const { decodeJwt } = await import('../vendor/jose');

  return decodeJwt(cookie) as T;
}
